import React, { useEffect } from 'react';

const PaytmIframeModal = ({ isOpen, onClose, iframeUrl, orderId }) => {
    useEffect(() => {
        if (isOpen) {
            // Listen for messages from iframe
            const handleMessage = (event) => {
                // Check if message is from Paytm domain
                if (event.origin.includes('paytm')) {
                    console.log('Message from Paytm iframe:', event.data);

                    // Handle different message types
                    if (event.data.type === 'PAYMENT_SUCCESS') {
                        alert('Payment successful!');
                        onClose();
                        window.location.reload();
                    } else if (event.data.type === 'PAYMENT_FAILED') {
                        alert('Payment failed!');
                        onClose();
                    }
                }
            };

            window.addEventListener('message', handleMessage);

            return () => {
                window.removeEventListener('message', handleMessage);
            };
        }
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <>
            {/* Backdrop */}
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 9998,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                onClick={onClose}
            >
                {/* Modal Container */}
                <div
                    style={{
                        position: 'relative',
                        width: '500px',
                        height: '850px',
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* Iframe */}
                    <iframe
                        src={iframeUrl}
                        title='Paytm Payment'
                        style={{
                            width: '100%',
                            height: '100%',
                            border: 'none',
                            display: 'block',
                        }}
                        sandbox='allow-forms allow-scripts allow-same-origin allow-popups allow-top-navigation'
                        allow='payment'
                    />
                </div>
            </div>
        </>
    );
};

export default PaytmIframeModal;
